import { Component, OnDestroy, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { AccountService } from 'src/app/services/account/account.service';
import { AnalyticsService } from 'src/app/services/general/analytics.service';
import { FunctionService } from 'src/app/services/general/function.service';
import { LinkService } from 'src/app/services/general/link.service';

@Component({
  selector: 'app-accounts-logout',
  templateUrl: './accounts-logout.page.html',
  styleUrls: ['./accounts-logout.page.scss'],
})
export class AccountsLogoutPage implements OnInit, OnDestroy {

  ready: boolean;

  constructor(
    private platform: Platform,
    private analyticsService: AnalyticsService,
    private accountService: AccountService,
    private linkService: LinkService,
    private functionService: FunctionService,
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  ionViewWillEnter() {
    this.ready = true;
    this.analyticsService.accountLogout(this.accountService.accountId);
  }

  /**
   * Before view enter
   */
  async ionViewDidEnter() {
    await this.platform.ready();
    await this.accountService.logoutAccount();
    await this.functionService.delay(200);
    await this.linkService.goMainPage(true);
  }

  ionViewWillLeave() {
    this.ready = false;
  }

}
